// Module
var code = "<widget-wrapper widget=\"$ctrl.widget\" class=\"grid-stack-item-content panel\"> <gauge-chart style=\"position:relative;display:block;height:100%\" data=\"$ctrl.widget.data\" options=\"$ctrl.widget.options\" total=\"$ctrl.widget.total\" chartOptions=\"$ctrl.widget.chartOptions\" class=\"gauge-chart\"></gauge-chart> </widget-wrapper> ";
// Exports
export default code;